import { render, staticRenderFns } from "./FormatDetail.vue?vue&type=template&id=20062e47"
import script from "./FormatDetail.vue?vue&type=script&lang=js"
export * from "./FormatDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports